import { render } from "./SelectedSearchBar.vue?vue&type=template&id=318da9d8&scoped=true"
import script from "./SelectedSearchBar.vue?vue&type=script&lang=js"
export * from "./SelectedSearchBar.vue?vue&type=script&lang=js"

import "./SelectedSearchBar.vue?vue&type=style&index=0&id=318da9d8&scoped=true&lang=css"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318da9d8"]])

export default __exports__